import React from 'react';
import './App.css';
import router from '@/routes';
import { useRoutes } from 'react-router-dom';
import 'antd/dist/reset.css';
import { fetcher } from '@/utils/request';
import { SWRConfig } from 'swr';

function App() {
  const routes = useRoutes(router);

  return (
    <>
      <SWRConfig
        value={{
          fetcher,
        }}
      >
        {routes}
      </SWRConfig>
    </>
  );
}

export default App;
